import { Form, FormActionsAlign, FormHandlers } from '@doveit/bricks';
import React from 'react';
import { Agent } from '../../../providers/api/dtos';
import AgentAutoComplete from '../../../containers/agent-autocomplete/AgentAutoComplete';
import { AgentStatus } from '../../../domain/types';
import { updateAssignedAgentFormValidationSchema } from './UpdateAssignedAgentForm.schema';

export interface UpdateAssignedAgentFormModel {
  assignee?: Agent,
}

export interface UpdateAssignedAgentFormProps {
  label?: string
  onSubmit: (values: UpdateAssignedAgentFormModel) => void,
  isRequired?: boolean,
  initialValues?: Partial<UpdateAssignedAgentFormModel>,
  innerRef?: React.MutableRefObject<FormHandlers>
  disabled?: boolean,
  loading?: boolean,
  noSubmit?: boolean,
}

export const DEFAULT_INITIAL_VALUES: UpdateAssignedAgentFormModel = {
  assignee: {} as Agent,
};

const UpdateAssignedAgentForm: React.FC<UpdateAssignedAgentFormProps> = ({
  initialValues,
  isRequired = false,
  label,
  ...rest
}) => {
  const mergedInitialValues: UpdateAssignedAgentFormModel = React.useMemo(() => ({
    ...DEFAULT_INITIAL_VALUES,
    ...initialValues,
  }), [initialValues]);

  return (
    <Form
      initialValues={mergedInitialValues}
      enableReinitialize
      validationSchema={updateAssignedAgentFormValidationSchema(isRequired)}
      {...rest}
    >
      <Form.Item>
        <AgentAutoComplete
          name="assignee"
          label={label || 'Agente assegnatario'}
          aria-label="Seleziona l'agente"
          placeholder="Cerca per nome"
          status={AgentStatus.ACTIVE}
          required={isRequired}
        />
      </Form.Item>
      {!rest.innerRef && (
        <Form.Actions align={FormActionsAlign.RIGHT}>
          <Form.Submit label="Modifica" />
        </Form.Actions>
      )}
    </Form>
  );
};

export default UpdateAssignedAgentForm;
